import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input} from "reactstrap";
import { useNotification } from "../../hooks/useNotification";
import  useApiRequests  from "../../hooks/useApiRequests"

interface MoveTaskProps {
  isOpen: boolean;
  toggleModal: () => void;
  taskId: string;
}



const MoveTaskModal: React.FC<MoveTaskProps> = ({
  isOpen,
  toggleModal,
  taskId
}) => {
  const [message, setMessage] = useState('');
  const { notify } = useNotification();

  const {
    taskInExternalFactor
  } = useApiRequests();

  const handleTaskInExternalFactor = async () => {

    try {

      const btn = document.getElementById("btn-create-task-external-factor");
      if(btn) {
        (btn as any).disabled = true;
        btn.innerHTML = "...";
      }
      const data = await taskInExternalFactor(taskId, message || "nothing")
      if(data.success) {
        notify(data.msg, {type:"success"})
      } else {
        notify(data.msg, { type: "error" });
      }
      
      toggleModal();

      if(btn) {
        (btn as any).disabled = false;
        btn.innerHTML = "Criar tarefa";
      }

      
      setMessage('')

    }catch(err) {
      notify(err, { type: "error" });
    }

  }



  return (

    


    <Modal
    className={`${
      localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"
    }`}
    isOpen={isOpen}
    toggle={() => toggleModal()}
  >
    <ModalHeader className="modal-header-style theme-text-color d-flex align-items-center justify-content-center">
      Criar Tarefa de Análise
    </ModalHeader>
    <ModalBody className="modal-body-style">
      <p className="theme-text-color text-center">O parceiro será notificado por email</p>
    {/* <Input
        className="input-modal theme-text-color"
        id="exampleText"
        name="text"
        type="textarea"
        rows="8"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      /> 
      vou deixar comentado o input para caso queiram colocar ele no futuro
      */} 

    </ModalBody>
    <ModalFooter className="modal-footer-style d-flex align-items-center justify-content-center">
      <Button
        color="primary"
        onClick={handleTaskInExternalFactor}
        id="btn-create-task-external-factor"
      >
        Criar tarefa
      </Button>{" "}
      <Button
        color="secondary"
        onClick={() => {
          toggleModal()
          setMessage('')
        }}
      >
        Cancelar
      </Button>
    </ModalFooter>
  </Modal>

  );
};

export default MoveTaskModal;
